import { eventsConstants } from '_store/_constants/events.constants';
import alertActions from '../alert.actions';
import eventsService from 'services/events.service';

export default function deleteWhatsAppConfig(id) {
  return async dispatch => {
    dispatch(request());

    try {
      await eventsService.deleteWhatsAppConfig(id);
      dispatch(success(id));
      dispatch(alertActions.success('Configuração do WhatsApp excluída com sucesso'));
      return true;
    } catch (error) {
      dispatch(failure(error));
      dispatch(alertActions.error('Erro ao excluir configuração do WhatsApp'));
      return false;
    }
  };

  function request() {
    return { type: eventsConstants.DELETE_WHATSAPP_CONFIG_REQUEST };
  }

  function success(id) {
    return {
      type: eventsConstants.DELETE_WHATSAPP_CONFIG_SUCCESS,
      id,
    };
  }

  function failure(error) {
    return { type: eventsConstants.DELETE_WHATSAPP_CONFIG_FAILURE, error };
  }
}
